import { flattenObjectByPrecedenceForAuthStorage } from './flattenObjectByPrecedenceForAuthStorage'

//TODO: review typings flattenDataFromResponse
/**
 * @param response
 * @returns {AuthData}
 */
export function flattenDataFromResponse(response) {
  let flattenedData = flattenObjectByPrecedenceForAuthStorage(response)
  if (response.productStates) {
    flattenedData = Object.assign({}, flattenedData, response.productStates[0])
  }
  if (response.goals) {
    flattenedData = Object.assign({}, flattenedData, { goals: response.goals })
  }
  return flattenedData
}
